import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { CONTACT, BUSINESSES } from "../siteConfig";

export default function Footer() {
  return (
    <footer data-testid="site-footer" data-theme="dark" className="border-t border-white/10 bg-obsidian-2">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
            Three specialised businesses delivering tyre, mining and tyre-management
            solutions across demanding industries.
          </p>
          <p className="mt-4 font-mono text-[10px] tracking-[0.25em] text-slate-300 uppercase">
            Dhanbad · Jharkhand · India
          </p>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-ember uppercase mb-5">Our Businesses</p>
          <ul className="space-y-3">
            {BUSINESSES.map((b) => (
              <li key={b.slug}>
                <Link
                  to={`/businesses/${b.slug}`}
                  data-testid={`footer-business-${b.slug}`}
                  className="font-condensed text-lg font-medium uppercase tracking-wide text-slate-300 hover:text-ember transition-colors"
                >
                  {b.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-ember uppercase mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-slate-400">
            <li><Link to="/products" data-testid="footer-products" className="hover:text-white transition-colors">Product Catalogue</Link></li>
            <li><Link to="/products?application=Mining" data-testid="footer-mining" className="hover:text-white transition-colors">Mining Solutions</Link></li>
            <li><Link to="/bkt" data-testid="footer-bkt" className="hover:text-white transition-colors">BKT Partnership</Link></li>
            <li><Link to="/insights" data-testid="footer-insights" className="hover:text-white transition-colors">Insights</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-ember uppercase mb-5">Head Office</p>
          <ul className="space-y-4 text-sm text-slate-400">
            <li className="flex gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-ember" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex gap-3 hover:text-white transition-colors">
                <Phone className="h-4 w-4 mt-0.5 shrink-0 text-ember" />
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex gap-3 hover:text-white transition-colors break-all">
                <Mail className="h-4 w-4 mt-0.5 shrink-0 text-ember" />
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex gap-3 hover:text-white transition-colors">
                <MessageCircle className="h-4 w-4 mt-0.5 shrink-0 text-ember" />
                WhatsApp us
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-mono text-[10px] tracking-[0.2em] text-slate-300 uppercase">
            © 2026 Mangalam Group. All rights reserved.
          </p>
          <p className="font-mono text-[10px] tracking-[0.15em] text-slate-200 uppercase">
            BKT is a trademark of Balkrishna Industries Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
}
